import { render, staticRenderFns } from "./suppo_ord.vue?vue&type=template&id=4ba0e494&scoped=true&"
import script from "./suppo_ord.vue?vue&type=script&lang=js&"
export * from "./suppo_ord.vue?vue&type=script&lang=js&"
import style0 from "./suppo_ord.vue?vue&type=style&index=0&id=4ba0e494&scoped=true&lang=less&"
import style1 from "./suppo_ord.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba0e494",
  null
  
)

export default component.exports